import React from "react";
import "./styles.css";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

const emptyBlacklistForm = { phone: "", details: "" };

export default class Blacklist extends React.Component {
  state = {
    blacklist: [],
    blacklistLoading: true,
    blacklistDialogOpen: false,
    blacklistForm: emptyBlacklistForm,
    blacklistSaving: false,
    blacklistDeletingId: null,
  };

  componentDidMount() {
    this.loadBlacklist();
  }

  loadBlacklist = async () => {
    this.setState({ blacklistLoading: true });
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get("https://api.appetito.ro/v1/admin/blacklist", {
        headers: { Authorization: `Bearer ${token}` },
      });
      this.setState({ blacklist: response.data || [] });
    } catch (e) {
      alert("Eroare la încărcarea listei negre.");
    } finally {
      this.setState({ blacklistLoading: false });
    }
  };

  openCreateBlacklistDialog = () => {
    this.setState({ blacklistDialogOpen: true, blacklistForm: emptyBlacklistForm });
  };

  closeBlacklistDialog = () => {
    this.setState({ blacklistDialogOpen: false, blacklistForm: emptyBlacklistForm });
  };

  updateBlacklistFormField = (field) => (event) => {
    this.setState({ blacklistForm: { ...this.state.blacklistForm, [field]: event.target.value } });
  };

  saveBlacklistEntry = async () => {
    const { blacklistForm } = this.state;
    if (!blacklistForm.phone.trim()) {
      alert("Completează numărul de telefon.");
      return;
    }

    this.setState({ blacklistSaving: true });
    try {
      const token = localStorage.getItem("access_token");
      await axios.post(
        "https://api.appetito.ro/v1/admin/blacklist",
        { phone: blacklistForm.phone.trim(), details: blacklistForm.details },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await this.loadBlacklist();
      this.closeBlacklistDialog();
    } catch (e) {
      alert("Eroare la salvarea intrării.");
    } finally {
      this.setState({ blacklistSaving: false });
    }
  };

  deleteBlacklistEntry = async (entry) => {
    if (!window.confirm(`Ștergi ${entry.phone} din lista neagră?`)) {
      return;
    }
    this.setState({ blacklistDeletingId: entry.id });
    try {
      const token = localStorage.getItem("access_token");
      await axios.delete(`https://api.appetito.ro/v1/admin/blacklist/${entry.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await this.loadBlacklist();
    } catch (e) {
      alert("Eroare la ștergerea intrării.");
    } finally {
      this.setState({ blacklistDeletingId: null });
    }
  };

  render() {
    const {
      blacklist,
      blacklistLoading,
      blacklistDialogOpen,
      blacklistForm,
      blacklistSaving,
      blacklistDeletingId,
    } = this.state;

    return (
      <div className="settings-container">
        <h2 className="settings-title">Listă neagră</h2>

        <div className="settings-section">
          <div className="settings-section-header">
            <h3 className="settings-section-title">Listă neagră</h3>
            <IconButton color="primary" onClick={this.openCreateBlacklistDialog} title="Adaugă în listă">
              <AddIcon />
            </IconButton>
          </div>
          <span className="settings-description">
            Numerele de telefon din această listă nu pot plasa comenzi cu plata cash.
          </span>

          {blacklistLoading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Table size="small" style={{ marginTop: 16 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Telefon</TableCell>
                  <TableCell>Detalii</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {blacklist.map((entry) => (
                  <TableRow key={entry.id}>
                    <TableCell>{entry.phone}</TableCell>
                    <TableCell>{entry.details}</TableCell>
                    <TableCell align="right">
                      <IconButton
                        size="small"
                        onClick={() => this.deleteBlacklistEntry(entry)}
                        disabled={blacklistDeletingId === entry.id}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {blacklist.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} style={{ textAlign: "center", color: "#888" }}>
                      Nicio intrare.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </div>

        <Dialog open={blacklistDialogOpen} onClose={this.closeBlacklistDialog} fullWidth maxWidth="xs">
          <DialogTitle>Adaugă în listă neagră</DialogTitle>
          <DialogContent>
            <TextField
              label="Telefon"
              fullWidth
              margin="normal"
              value={blacklistForm.phone}
              onChange={this.updateBlacklistFormField("phone")}
            />
            <TextField
              label="Detalii"
              fullWidth
              multiline
              rows={3}
              margin="normal"
              value={blacklistForm.details}
              onChange={this.updateBlacklistFormField("details")}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeBlacklistDialog} disabled={blacklistSaving}>
              Anulează
            </Button>
            <Button
              onClick={this.saveBlacklistEntry}
              color="primary"
              variant="contained"
              disabled={blacklistSaving}
            >
              Salvează
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
